<template>
  <div class="container__request">
    <div class="table__container">
      <table class="request__table">
        <tbody>
        <tr v-for="key in Object.keys(requestSchema.properties)">
          <td class="req__keys">
            <div class="req__key__required">
              {{ key }}
              <div v-for="req in requestSchema.required">
                <span class="after" v-if="key === req"> *required</span>
              </div>
            </div>
            <div class="req__type">
              {{ requestSchema.properties[key].type }}
            </div>
          </td>

          <td class="req__description">
            <div
                v-html="converted(requestSchema.properties[key].description)"
            ></div>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import webhook from '../data/document/schemas/webhook.yaml';

import MarkdownIt from 'markdown-it';
import {maxDepth, recursiveParser} from '../data/userData';

export default {
  name: 'RequestBodyComponent',
  props: {
    requests: Object,
  },
  methods: {
    converted(description) {
      const md = new MarkdownIt();
      let converted = md.render(description);
      converted = converted.replaceAll('&lt;br&gt;', '<br>');
      return converted;
    },
  },
  computed: {
    requestSchema() {
      if (!this.requests) return;
      const depth = maxDepth(this.requests.schema);
      this.requests.schema = recursiveParser(
          this.requests.schema,
          depth,
          webhook,
      );
      return this.requests.schema;
    },
  },
};
</script>

<style scoped lang="scss">
div {
  font-size: 14px;
  display: block;
  font-family: Meiryo, sans-serif;
}

table {
  display: table;
  text-indent: initial;
  border-spacing: 2px;
  border-color: grey;
}

tr {
  display: table-row;
  vertical-align: inherit;
  border-color: inherit;
}

td {
  display: table-cell;
}

table tbody tr td {
  padding: 10px 0 0;
  vertical-align: top;
}

.after {
  font-size: 10px;
  position: relative;
  top: -6px;
  padding: 5px;
  content: 'required';
  color: rgba(255, 0, 0, 0.6);
}

.container__request {
  font-size: 12px;
  margin: 0 0 5px;
  padding: 15px 20px;
  font-family: sans-serif;
  color: #3b4151;
}

.table__container {
  padding: 20px;
}

.req__keys {
  min-width: 10em;
  padding: 10px 0;
  font-size: 16px;
  margin-right: 0.75em;
  font-family: sans-serif;
  color: #3b4151;

  .req__key__required {
    font-weight: 700;
    font-size: 16px;
    display: flex;
  }

  .req__type {
    font-size: 12px;
    padding: 5px 0;
    font-family: monospace;
    font-weight: 600;
    color: #3b4151;
  }
}

.req__description {
  width: 99%;
  margin-bottom: 2em;
}

div::v-deep p {
  margin-top: 0;

  code {
    border-radius: 2px;
    background-color: rgba(51, 51, 51, 0.05);
    color: rgba(51, 51, 51, 0.9);
    padding: 0px 5px;
    border: 1px solid rgba(51, 51, 51, 0.1);
    font-family: Courier, monospace;
  }
}
</style>
